import Index from '../../pages/hjwq/newArea-appoint/index';
import Pc from '../../pages/hjwq/newArea-appoint/pc';

const base = 'newArea-appoint';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/newArea-appoint.js